import PropTypes from 'prop-types';

export const AppointmentInformation = ({ listItem }) => (
  <ul>
    <li>
      Please aim to arrive
      <strong> 5 minutes before </strong>
      your appointment time
    </li>
    <li>
      To save time, we&apos;d recommend you register for your Gift List{' '}
      <a
        href="https://www.johnlewisgiftlist.com/giftint/register?command=InitialiseScreen"
        target="_blank"
        rel="noopener noreferrer"
      >
        here
      </a>{' '}
      before you come for your appointment
    </li>
    {listItem}
  </ul>
);

AppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};
